export default __webpack_public_path__ + "static/media/master.269563ef.svg";